module.exports = __webpack_public_path__ + "img/maTouQin1.70d175e4.png";